// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__yunXS","footerItem":"Footer_footerItem__u+A+i"};